import CustomText from './CustomText';
import types from './types';
import variants from './variants';

export { types, variants };

export default CustomText;
